module.exports = __webpack_public_path__ + "img/qfi_banner_title.585ee151.png";